








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class TextField extends Vue {
  @Prop({required: true}) value!: string | null;
  @Prop({default: true, type: Boolean}) showChangeState!: boolean;
  @Prop() initialValue!: number | undefined;

  private localInitialValue: string | null = null;

  get listeners() {
    return Object.assign({}, this.$listeners, {
      input: (value: any) => this.$emit('input', value),
      change: (value: any) => this.$emit('input', value),
    });
  }

  get realInitialValue() {
    return typeof this.initialValue != 'undefined' ? this.initialValue : this.localInitialValue;
  }

  created() {
    this.localInitialValue = this.value;
  }
}
